import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "home",
  "title": "Les progrès de l’éducation",
  "lead": "L’éducation éclaire chaque étape du chemin qui mène à une vie meilleure. Tous les enfants ont besoin d’avoir accès à une éducation de bonne qualité pour réaliser leur potentiel d’apprentissage et profiter des bienfaits plus généraux de l’éducation. Des efforts particuliers doivent être entrepris pour que son pouvoir de transformation bénéficie équitablement à tous les enfants et les jeunes. Cela exige des ressources suffisantes, notamment pour atteindre ceux qui ont davantage besoin de soutien."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {HighlightByTheme, IndexHero, LandingButton, LandingText, PageLink, RelatedContent, ThemeLinks} = _components;
  if (!HighlightByTheme) _missingMdxReference("HighlightByTheme", true);
  if (!IndexHero) _missingMdxReference("IndexHero", true);
  if (!LandingButton) _missingMdxReference("LandingButton", true);
  if (!LandingText) _missingMdxReference("LandingText", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedContent) _missingMdxReference("RelatedContent", true);
  if (!ThemeLinks) _missingMdxReference("ThemeLinks", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(IndexHero, {
      children: [_jsx(_components.h1, {
        id: "scope",
        children: "SCOPE"
      }), _jsxs(_components.p, {
        children: ["L’éducation éclaire chaque étape du chemin qui mène à une vie meilleure. Tous les enfants ont besoin d’avoir ", _jsx(HighlightByTheme, {
          theme: "access",
          children: "accès"
        }), " à une éducation de bonne ", _jsx(HighlightByTheme, {
          theme: "quality",
          children: "qualité"
        }), " pour réaliser leur potentiel d’", _jsx(HighlightByTheme, {
          theme: "learning",
          children: "apprentissage"
        }), " et profiter des bienfaits plus généraux de l’éducation. Des efforts particuliers doivent être entrepris pour que son pouvoir de transformation bénéficie ", _jsx(HighlightByTheme, {
          theme: "equity",
          children: "équitablement"
        }), " à tous les enfants et les jeunes. Cela exige des", _jsx(HighlightByTheme, {
          theme: "finance",
          children: "ressources"
        }), ", notamment pour atteindre ceux qui ont davantage besoin de soutien."]
      })]
    }), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["En 2015, la communauté internationale a inclus un objectif sur l’éducation ", _jsx(_components.a, {
          href: "https://sustainabledevelopment.un.org/sdg4",
          children: "l'ODD 4"
        }), ", parmi les 17 Objectifs de développement durable à atteindre avant 2030. Depuis, un ", _jsx(PageLink, {
          name: "indicateurs",
          children: "cadre détaillé "
        }), " a été mis en place pour suivre les progrès accomplis en faveur des cibles de l’Objectif. Le présent site récapitule les principaux faits et tendances de l’éducation dans le monde à travers cinq thèmes :"]
      })
    }), "\n", _jsx(ThemeLinks, {}), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["Il complète les informations présentées dans la version imprimée du ", _jsx(_components.a, {
          href: "https://fr.unesco.org/gem-report/allreports",
          children: "Rapport mondial de suivi sur l’éducation"
        }), ", instrument qui permet à la communauté internationale de suivre et d’examiner les progrès réalisés en faveur de notre objectif sur l’éducation, l’ODD 4."]
      })
    }), "\n", _jsx(LandingButton, {
      children: "Commencer à lire"
    }), "\n", _jsx(RelatedContent, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
